import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

import { AuthProvider } from "components/Auth/AuthContext";

// layouts
import Admin from "layouts/Admin.js";
import Tentor from "layouts/Tentor";
import Auth from "layouts/Auth.js";

// views without layouts
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import Index from "views/Index.js";
import Invoice from "views/InvoiceView";

// PrivateRoute component
import ProtectedRoute from 'components/Auth/ProtectedRoute'; // Import PrivateRoute

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <Switch>
        {/* Protected routes */}
        <ProtectedRoute path="/admin" component={Admin} roles={['admin']} />
        <ProtectedRoute path="/tentor" component={Tentor} roles={['tentor']} />
        {/* Routes without layouts */}
        <Route path="/auth" component={Auth} />
        <Route path="/landing" exact component={Landing} />
        <Route path="/profile" exact component={Profile} />
        <Route path="/8gy78gyug87b78iuyg767/cetak/invoice/:siswaId/:firtsTentorId/:sortMonth" exact component={Invoice} />
        <Route path="/" exact component={Landing} />
        
        {/* Redirect for unknown paths */}
        {/* <Redirect from="*" to="/" /> */}
      </Switch>
    </AuthProvider>
  </BrowserRouter>
);
